var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 14.75h13.5M9.338 2.984s0 1.226 1.226 2.452 2.452 1.226 2.452 1.226m-8.526 5.83 2.574-.369c.372-.053.716-.225.981-.49l6.197-6.197a1.734 1.734 0 0 0 0-2.452l-1.226-1.226a1.734 1.734 0 0 0-2.452 0L4.367 7.955c-.265.265-.437.61-.49.98l-.368 2.575a.867.867 0 0 0 .98.981Z",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export default SvgEdit;